(ns hai.ui.components.collection.views.utils
  (:require
   [hai.sharing.helper :as sharing]
   [hai.ui.components :as c]
   [hai.ui.rf-sugar :refer [<s]]))

(defn classes
  [{:form/keys [dirty? valid?] :as row}]
  (cond-> []
    dirty? (conj "dirty")
    valid? (conj "valid")
    (not valid?) (conj "invalid")))

(defn editable?
  [{collection-editable? :collection/editable? :as _table}
   {:form/keys [current-value] :as _row}
   {:table.column/keys [attr field] :as _column}]
  (and field
       attr
       (or collection-editable?
           (sharing/can-edit? current-value))))

(defn render-cell-or-field
  [render-field
   table
   {:form/keys [fields current-value] :as row}
   {:table.column/keys [attr field] :as column}]
  (let [selected? @(<s [:table/selected? table current-value])]
    (if (editable? table row column)

      [field
       (cond-> (get fields attr)
         selected? (assoc :table/selected? true)
         ;; TODO this needs to be added by the collection as card edit is not in the field
         :always (assoc :collection/entity current-value))
       row]

      [render-field
       table
       (cond-> current-value
         selected? (assoc :table/selected? true))
       column])))

